import { schema } from 'normalizr';

import { surveyQuestionsCollectionSchema } from '../SurveyQuestions/schema';

export const name = 'surveys';

export const surveySchema = new schema.Entity(name, {
  surveyQuestions: surveyQuestionsCollectionSchema,
});
